export enum Command {
    OPEN_HUMAN_INSIGHT_TAB = 'insight:openHumanInsightTab',
}
